import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';

class FFCommunity {
	currentFilter = 'item-features';

	$grid!: HTMLElement;
	$filters!: NodeListOf<HTMLAnchorElement>;
	iso!: Isotope;

	constructor() {
		this.cache();
		this.events();
		this.grid();
	}

	cache() {
		this.$grid = document.querySelector('#sctn-comm-gallery .grid') as HTMLElement;
		this.$filters = document.querySelectorAll('#sctn-comm-gallery .filters a');
	}

	events() {
		for (let i = 0; i < this.$filters.length; i++) {
			this.$filters[i].addEventListener('click', this.filter.bind(this));
		}
	}

	filter(e: Event) {
		const targ = e.currentTarget as HTMLAnchorElement;
		const filter = targ.getAttribute('data-filter');
		if (!filter || filter === this.currentFilter) return;

		const filterClass = '.' + filter;

		for (let i = 0; i < this.$filters.length; i++) {
			this.$filters[i].classList.remove('active');
		}
		targ.classList.add('active');
		this.iso.arrange({ filter: filterClass });

		this.currentFilter = filter;
	}

	grid() {
		this.iso = new Isotope(this.$grid, {
			itemSelector: '.item',
			layoutMode: 'masonry',
			filter: '.item-studio',
		});
		imagesLoaded(this.$grid, this.update_grid.bind(this));
	}

	update_grid() {
		this.iso.layout();
	}
}

new FFCommunity();
